import { Link } from "react-router-dom";
import useShoppingCart from "../../../../hooks/useShoppingCart.hook";
import "./shoppingCartHeaderIconComponent.scss"

const ShoppingCartHeaderIconComponent = () => {
  // Get the total products from the shopping cart state
  const { totalProducts } = useShoppingCart();

  return (
    <Link to="/shoppingCart" className="shppongCartIconContainer">
      <i className="fa fa-shopping-cart"></i>
      {totalProducts > 0 && <span className="cart-bubble">{totalProducts}</span>}
    </Link>
  );
};

export default ShoppingCartHeaderIconComponent;
